export default __webpack_public_path__ + "static/media/IMG_0896.9e9c44ba.jpg";